import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";
import { useParams } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { postFetcher } from "api/swr";

/** POST `/spine-drafts/:id/submit` — writes draft, template state for review. */
export function SubmitReviewButton() {
  const { tid } = useParams<{ tid: string }>();

  const { trigger, isMutating } = useSWRMutation(
    tid ? `/spine-drafts/${tid}/submit` : null,
    postFetcher,
    {
      onSuccess: () => {
        toast({ title: "Submitted for review", className: "bg-green-500 text-white" });
      },
      onError: (error: Error) => {
        toast({ variant: "destructive", title: "Submit failed", description: error.message });
      },
    },
  );

  return (
    <Button
      onClick={() => void trigger({})}
      disabled={isMutating || !tid}
      className="gap-1"
    >
      <Send className="h-4 w-4" />
      {isMutating ? "Submitting…" : "Submit for review"}
    </Button>
  );
}
